import React from 'react'

import { CommonCardProps } from '../../cards/CardItem.Props'

import { Profile } from '@news-mono/web-common'
import { Skeleton } from '../../content/Skeleton/Skeleton'

import {
    StyledHeadshotWrapper,
    StyledHeadshot,
    StyledByline,
    StyledBylineText,
    StyledBylineTextWithHeadshot,
    StyledBylineName,
    StyledBylinePosition,
} from '../../cards/CardByline/CardByline.styled'

import { themedValue } from '../../__styling/themed-value'
import { MaybeLoaded } from 'json-react-layouts-data-loader'
import { useTheme } from '@emotion/react'
import { PublicationCardItem } from '@news-mono/web-common'
import { scaleImage } from '@news-mono/web-common'

export interface CardBylineProps extends CommonCardProps {
    className?: string
    hasBackground?: boolean
    showProfile?: boolean
    isEdgeToEdgeCard?: boolean
    item: MaybeLoaded<PublicationCardItem>
}

export const CardByline: React.FC<CardBylineProps> = (props) => {
    const theme = useTheme()
    const {
        className,
        hasBackground,
        item,
        showProfile,
        isEdgeToEdgeCard,
    } = props

    const hasBackgroundColor = themedValue(theme, {
        perthnow: hasBackground,
        fallback: undefined,
    })

    if (!item.loaded) {
        return (
            <StyledByline className={className} hasPadding={false}>
                <Skeleton
                    count={1}
                    height={53}
                    dark={hasBackgroundColor || false}
                />
            </StyledByline>
        )
    }

    if (
        showProfile &&
        item.result.profiles &&
        item.result.profiles.length !== 0
    ) {
        return renderBylineWithProfile(
            item.result.profiles,
            item.result.byline,
            !!isEdgeToEdgeCard,
            className,
        )
    }
    if (showProfile) {
        return (
            <StyledByline className={className} hasPadding={!!isEdgeToEdgeCard}>
                <StyledBylineText>{item.result.byline}</StyledBylineText>
            </StyledByline>
        )
    }

    return (
        <StyledByline className={className} hasPadding={!!isEdgeToEdgeCard}>
            <StyledBylineText>{item.result.byline}</StyledBylineText>
        </StyledByline>
    )
}

function getProfileImage(profile: Profile[]): string | undefined {
    const profileImage = profile.slice(0).map((item) => {
        return item.thumbnailPhoto ? item.thumbnailPhoto : undefined
    })[0]

    return profileImage ? scaleImage(profileImage, 110) : profileImage
}

function getProfileText(
    profile: Profile[] | undefined,
    text: string | undefined,
) {
    if (profile && profile.length !== 0) {
        const profileBlock = profile.map((item, index) => {
            return (
                <React.Fragment key={index}>
                    <StyledBylineName>{item.name}</StyledBylineName>
                    <StyledBylinePosition>{item.position}</StyledBylinePosition>
                </React.Fragment>
            )
        })

        return profileBlock
    }

    return text
}

function renderBylineWithProfile(
    profile: Profile[],
    byline: string,
    isEdgeToEdgeCard: boolean,
    className?: string,
) {
    const imageSrc = getProfileImage(profile)
    return (
        <StyledByline hasPadding={isEdgeToEdgeCard} className={className}>
            {imageSrc && (
                <StyledHeadshotWrapper>
                    <StyledHeadshot src={imageSrc} alt={byline} />
                </StyledHeadshotWrapper>
            )}
            <StyledBylineTextWithHeadshot>
                {getProfileText(profile, byline)}
            </StyledBylineTextWithHeadshot>
        </StyledByline>
    )
}
CardByline.displayName = 'CardByline'
